// You can write more code here

/* START OF COMPILED CODE */

import Mentor5 from '@/game/prefabs/World/Mentors/Mentor5';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level21 extends TilemapScene {
  constructor() {
    super('Level21');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // tropical_biome_1
    const tropical_biome_1 = this.add.tilemap('tropical-biome-1');
    tropical_biome_1.addTilesetImage(
      'tropical shores prefabs & samples',
      'tropical shores prefabs & samples',
    );
    tropical_biome_1.addTilesetImage('collision', 'collision & alpha');
    tropical_biome_1.addTilesetImage(
      'tropical shores, just trees',
      'tropical shores, just trees',
    );
    tropical_biome_1.addTilesetImage('tropical shores', 'tropical shores');

    // terrain_1
    tropical_biome_1.createLayer(
      'terrain',
      ['tropical shores prefabs & samples', 'tropical shores'],
      0,
      0,
    );

    // terrain_deco_1
    tropical_biome_1.createLayer('terrain deco', ['tropical shores'], 0, 0);

    // deco_1
    tropical_biome_1.createLayer(
      'deco',
      ['tropical shores, just trees', 'tropical shores'],
      0,
      0,
    );

    // water_1
    tropical_biome_1.createLayer(
      'water',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // tOP_trees_1
    tropical_biome_1.createLayer(
      'TOP trees',
      ['tropical shores, just trees'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = tropical_biome_1.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 88, 152);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 200, 368);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 536, 312);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 208, 96);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 528, 112);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 728, 32);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 752, 336);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 800, 32);
    this.add.existing(portal);

    // mentor
    const mentor = new Mentor5(this, 80, 208);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 376, 328);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 656, 64);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 112, 224);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 496, 424);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 20;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 20;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 20;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 20;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 20;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 20;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 20;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 20;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 20;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 20;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.tropical_biome_1 = tropical_biome_1;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor5;
  private tropical_biome_1!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.tropical_biome_1,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
